module.exports = __webpack_public_path__ + "img/histogram_chart.eebf795e.svg";